import { CreditRewardsList } from '../components/credit-rewards/CreditRewardsList';
import { useCreditRewardsServices } from '../services/useCreditRewardsServices';

export const CreditRewardsContainer = () => {
  const services = useCreditRewardsServices();

  if (!services.reward.length) {
    return null;
  }

  return <CreditRewardsList data={services.reward} />;
};
